import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { initializePersistentStorage } from './lib/persistence/storage.js';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

async function bootstrap() {
  await initializePersistentStorage();

  const [{ default: App }, { ThemeProvider }] = await Promise.all([
    import('./App'),
    import('./components/common/ThemeProvider'),
  ]);

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <HashRouter>
            <App />
          </HashRouter>
        </ThemeProvider>
      </QueryClientProvider>
    </StrictMode>
  );
}

void bootstrap();
